import { zeroAddress } from "viem";
import { getChain } from "../helpers";
export const usdcContractAddress = (() => {
    return usdcAddressForChain(getChain());
})();
export const eurcContractAddress = (() => {
    return eurcAddressForChain(getChain());
})();
export function usdcAddressForChain(chain) {
    if (chain.name === "Sepolia") {
        return "0x7Fc21ceb0C5003576ab5E101eB240c2b822c95d2";
    }
    if (chain.name === "Arbitrum One") {
        return "0xaf88d065e77c8cC2239327C5EDb3A432268e5831";
    }
    if (chain.name === "Base") {
        return "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
    }
    if (chain.name === "Base Sepolia") {
        return "0x036CbD53842c5426634e7929541eC2318f3dCF7e";
    }
    throw new Error(`Network not supported: ${chain.name}}`);
}
export function eurcAddressForChain(chain) {
    if (chain.name === "Base") {
        return "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42";
    }
    if (chain.name === "Base Sepolia") {
        return "0x808456652fdb597867f38412077A9182bf77359F";
    }
    if (chain.name === "Arbitrum One") {
        return zeroAddress;
    }
    throw new Error(`Network not supported: ${chain.name}}`);
}
